<div class="document-block mt-2">

    <!-- info of khasra -->
    <div class="formSection">
        <div class="head">
            <strong>Khasra Info </strong>
        </div>
        <div class="row m-2">
            <div class="col-md-4">
                <div><strong>Khasra No : </strong> {{ currentKhasraData?.name }}</div>
                <div><strong>Area:</strong> {{ currentKhasraData?.area }}
                    {{currentKhasraData?.unitOfMeasure?.name}}</div>
            </div>
            <div class="col-md-4">
                <div><strong>Status: </strong> {{currentKhasraData?.status}}</div>
                <div><strong>Khata No: </strong>{{currentKhasraData?.landKhata?.name}}</div>
            </div>
            <div class="col-md-4">
                <div><strong>Partner :</strong>
                    &nbsp; <i class="fa fa-eye" (click)="openPartnerModal(currentKhasraData)"></i>
                </div>
            </div>
            <div class="col-md-12">
                <div><strong>Address:</strong> {{ currentKhasraData?.village?.name + ' / ' +
                    currentKhasraData?.village?.tehsil?.name + ' / ' +
                    currentKhasraData?.village?.tehsil?.district?.name + ' / ' +
                    currentKhasraData?.village?.tehsil?.district?.state?.name}}
                </div>
            </div>
        </div>
    </div>

    <!-- Address -->
    <div class="formSection">
        <div class="head">
            <strong>Farmers ({{currentKhasraData?.farmers ? currentKhasraData?.farmers?.length : '0'}})</strong>
            <span style="float: right; cursor: pointer;">
                <img src="../../assets/images/DashboardIcon.svg" style="height:30px; width: 30px; padding-top: 0px;"
                    (click)="showHideFarmerAnshGraph(true)" />
            </span>
        </div>
        <table>
            <th class="col-md-4">Farmer Name</th>
            <th class="col-md-4">Area ({{currentKhasraData?.unitOfMeasure?.name}})</th>
            <th class="col-md-4">Payment</th>
            <tr *ngFor="let farmer of currentKhasraData?.farmers">
                <td>
                    <span class="modal-hyperlink-text" (click)="openFarmerModal(farmer)">
                        {{
                        ((farmer?.nameInitial?.name)?(farmer?.nameInitial?.name):'') + " " +
                        ((farmer?.firstName)?(farmer?.firstName):'') + " " +
                        ((farmer?.lastName)?(farmer?.lastName):'')}}
                        <span *ngIf="farmer?.aadharNo">({{farmer?.aadharNo}})</span>
                    </span>
                </td>
                <td>{{farmer?.area}}</td>
                <td>{{(farmer?.amountPaid)?(commonService.formatIndianCurrency(farmer?.amountPaid)):'0'}}</td>
            </tr>
            <tr></tr>
            <td class="submissionData font-weight-bolder">
                Total
            </td>
            <td class="submissionData font-weight-bolder">{{currentKhasraData?.area}}</td>
            <td class="submissionData font-weight-bolder">{{currentKhasraData?.paidAmount}}</td>
        </table>
    </div>

    <!-- Adjacent khasra -->
    <div class="formSection">
        <div class="head">
            <strong>Adjacent Khasra ({{currentKhasraData?.adjacentLandKhasra ?
                currentKhasraData?.adjacentLandKhasra?.length : '0'}})</strong>
        </div>
        <table>
            <th>Khasra Name</th>
            <th>Plot No</th>
            <th>Area</th>
            <tr *ngFor="let khasra of currentKhasraData?.adjacentLandKhasra">
                <td>
                    <!-- if khasra has status then only it will be clickable as we will be having it's details -->
                    <span class="modal-hyperlink-text" *ngIf="khasra?.status" (click)="openKhasraModal(khasra)">
                        {{khasra?.name}}</span>

                    <!-- if khasra has no status it will not be clickable as we won't be having it's details -->
                    <span *ngIf="!khasra?.status">({{khasra?.name}})</span>
                </td>
                <td>{{khasra?.plotNo}}</td>
                <td>{{khasra?.area}}</td>
            </tr>
            <!-- <tr>
        </tr>
        <td class="submissionData font-weight-bolder">Total Area</td>
        <td class="submissionData">0 Biswa</td> -->
        </table>
    </div>

    <!-- other khasra of same khata -->
    <div class="formSection">
        <div class="head">
            <strong>Other Khasra of Khata ({{otherkhasraofCurrentKhata?.length >0 ? otherkhasraofCurrentKhata?.length :
                0}})</strong>
        </div>

        <table>
            <th>Khasra Number</th>
            <th>Area (Biswa)</th>
            <tr *ngFor="let khasra of otherkhasraofCurrentKhata">
                <td>
                    <!-- if khasra has status then only it will be clickable as we will be having it's details -->
                    <span class="modal-hyperlink-text" *ngIf="khasra?.status" (click)="openKhasraModal(khasra)">
                        {{khasra?.name}}</span>

                    <!-- if khasra has no status it will not be clickable as we won't be having it's details -->
                    <span *ngIf="!khasra?.status">({{khasra?.name}})</span>
                </td>
                <td>{{khasra?.area}}</td>
            </tr>
            <tr>
            </tr>
            <td class="submissionData font-weight-bolder">Total Area</td>
            <td class="submissionData font-weight-bolder">{{totalAreaofOtherKhasra}}</td>
        </table>
    </div>
</div>

<!-- Chart Section for Farmer Ansh Starts-->
<p-dialog header="Khasra Details : (# {{currentKhasraData?.name}})" [(visible)]="showFarmerAnshChart"
    (onHide)="showHideFarmerAnshGraph(false)" [modal]="true" [style]="{width: '30vw'}" [closable]="true"
    [resizable]="false">
    <div class="row" style="text-align: center;">
        <app-common-chart [chartOptions]="farmerAnshChartDataOptions"></app-common-chart>
    </div>
    <!-- <app-common-chart [chartOptions]="farmerAnshChartDataOptions1"></app-common-chart> -->
</p-dialog>
<!-- Chart Section for Farmer Ansh Starts-->